export enum PermissionKeys {
  TENANT_READ = 'TENANT_READ',
  TENANT_CREATE = 'TENANT_CREATE',
  TENANT_UPDATE = 'TENANT_UPDATE',
  TENANT_ONBOARDING_DATAZONE_NONPII = 'TENANT_ONBOARDING_DATAZONE_NONPII',
  TENANT_ONBOARDING_DATAZONE_PII = 'TENANT_ONBOARDING_DATAZONE_PII',
  TENANT_ONBOARDING_DATAZONE_LIVE = 'TENANT_ONBOARDING_DATAZONE_LIVE',
  INSTANCE_SFTP_CONFIG_DATAZONE_NONPII = 'INSTANCE_SFTP_CONFIG_DATAZONE_NONPII',
  INSTANCE_SFTP_CONFIG_DATAZONE_PII = 'INSTANCE_SFTP_CONFIG_DATAZONE_PII',
  INSTANCE_SFTP_CONFIG_DATAZONE_LIVE = 'INSTANCE_SFTP_CONFIG_DATAZONE_LIVE',
  BLUEPRINT_READ = 'BLUEPRINT_READ',
  INSTANCE_UPDATE_DATAZONE_NONPII = 'INSTANCE_UPDATE_DATAZONE_NONPII',
  INSTANCE_UPDATE_DATAZONE_PII = 'INSTANCE_UPDATE_DATAZONE_PII',
  INSTANCE_UPDATE_DATAZONE_LIVE = 'INSTANCE_UPDATE_DATAZONE_LIVE',
  INSTANCE_READ_DATAZONE_NONPII = 'INSTANCE_READ_DATAZONE_NONPII',
  INSTANCE_READ_DATAZONE_PII = 'INSTANCE_READ_DATAZONE_PII',
  INSTANCE_READ_DATAZONE_LIVE = 'INSTANCE_READ_DATAZONE_LIVE',
  INSTANCE_DR_DATAZONE_LIVE = 'INSTANCE_DR_DATAZONE_LIVE',
  INSTANCE_CONFIG_DATAZONE_NONPII = 'INSTANCE_CONFIG_DATAZONE_NONPII',
  INSTANCE_CONFIG_DATAZONE_PII = 'INSTANCE_CONFIG_DATAZONE_PII',
  INSTANCE_CONFIG_DATAZONE_LIVE = 'INSTANCE_CONFIG_DATAZONE_LIVE',

  INSTANCE_DELETE_DATAZONE_NONPII = 'INSTANCE_DELETE_DATAZONE_NONPII',
  INSTANCE_DELETE_DATAZONE_PII = 'INSTANCE_DELETE_DATAZONE_PII',
  INSTANCE_DELETE_DATAZONE_LIVE = 'INSTANCE_DELETE_DATAZONE_LIVE',
  INSTANCE_START_DATAZONE_NONPII = 'INSTANCE_START_DATAZONE_NONPII',
  INSTANCE_START_DATAZONE_PII = 'INSTANCE_START_DATAZONE_PII',
  INSTANCE_STOP_DATAZONE_NONPII = 'INSTANCE_STOP_DATAZONE_NONPII',
  INSTANCE_STOP_DATAZONE_PII = 'INSTANCE_STOP_DATAZONE_PII',
  INSTANCE_CREATE_DATAZONE_NONPII = 'INSTANCE_CREATE_DATAZONE_NONPII',
  INSTANCE_CREATE_DATAZONE_PII = 'INSTANCE_CREATE_DATAZONE_PII',
  INSTANCE_CREATE_DATAZONE_LIVE = 'INSTANCE_CREATE_DATAZONE_LIVE',
  BLUEPRINT_CREATE = 'BLUEPRINT_CREATE',
  CONFIGURATION_READ = 'CONFIGURATION_READ',
  INSTANCE_CREATE = 'INSTANCE_CREATE',
  BLUEPRINT_DELETE = 'BLUEPRINT_DELETE',
  BLUEPRINT_UPDATE = 'BLUEPRINT_UPDATE',
  INSTANCE_AGENT_MANAGE_DATAZONE_NONPII = 'INSTANCE_AGENT_MANAGE_DATAZONE_NONPII',
  INSTANCE_AGENT_MANAGE_DATAZONE_PII = 'INSTANCE_AGENT_MANAGE_DATAZONE_PII',
  INSTANCE_AGENT_MANAGE_DATAZONE_LIVE = 'INSTANCE_AGENT_MANAGE_DATAZONE_LIVE',
  SOLUTION_READ = 'SOLUTION_READ',
  SOLUTION_CREATE = 'SOLUTION_CREATE',
  SOLUTION_UPDATE = 'SOLUTION_UPDATE',
  SOLUTION_DELETE = 'SOLUTION_DELETE',
  INSTANCE_TEST_DATAZONE_NONPII = 'INSTANCE_TEST_DATAZONE_NONPII',
  INSTANCE_TEST_DATAZONE_PII = 'INSTANCE_TEST_DATAZONE_PII',
  INSTANCE_TEST_DATAZONE_LIVE = 'INSTANCE_TEST_DATAZONE_LIVE',

  JUMPBOX_CREATE_PII = 'JUMPBOX_CREATE_PII',
  JUMPBOX_CREATE_LIVE = 'JUMPBOX_CREATE_LIVE',
  JUMPBOX_DELETE_PII  = 'JUMPBOX_DELETE_PII',
  JUMPBOX_DELETE_LIVE  = 'JUMPBOX_DELETE_LIVE',
  JUMPBOX_READ_PII = 'JUMPBOX_READ_PII',
  JUMPBOX_READ_LIVE = 'JUMPBOX_READ_LIVE',
  JUMPBOX_UPDATE_PII = 'JUMPBOX_UPDATE_PII',
  JUMPBOX_UPDATE_LIVE = 'JUMPBOX_UPDATE_LIVE',

  PRIVATE_EP_APPROVE_PII =' PRIVATE_EP_APPROVE_PII',
  PRIVATE_EP_APPROVE_LIVE =' PRIVATE_EP_APPROVE_LIVE',
  PRIVATE_EP_REJECT_PII ='PRIVATE_EP_REJECT_PII',
  PRIVATE_EP_REJECT_LIVE ='PRIVATE_EP_REJECT_LIVE',
  PRIVATE_EP_DELETE_PII = 'PRIVATE_EP_DELETE_PII',
  PRIVATE_EP_DELETE_LIVE = 'PRIVATE_EP_DELETE_LIVE',
  PRIVATE_EP_CREATE_PII = 'PRIVATE_EP_CREATE_PII',
  PRIVATE_EP_CREATE_LIVE = 'PRIVATE_EP_CREATE_LIVE',
  PRIVATE_EP_READ_PII = 'PRIVATE_EP_READ_PII',
  PRIVATE_EP_READ_LIVE = 'PRIVATE_EP_READ_LIVE',

  SCHEDULE_READ = 'SCHEDULE_READ',
  SCHEDULE_CREATE = 'SCHEDULE_CREATE',
  SCHEDULE_UPDATE = 'SCHEDULE_UPDATE',
  SCHEDULE_DELETE = 'SCHEDULE_DELETE',

  SCHEDULE_READ_NONPII = 'SCHEDULE_READ_NONPII',
  SCHEDULE_CREATE_NONPII = 'SCHEDULE_CREATE_NONPII',
  SCHEDULE_UPDATE_NONPII = 'SCHEDULE_UPDATE_NONPII',
  SCHEDULE_DELETE_NONPII = 'SCHEDULE_DELETE_NONPII',
  SCHEDULE_READ_PII = 'SCHEDULE_READ_PII',
  SCHEDULE_CREATE_PII = 'SCHEDULE_CREATE_PII',
  SCHEDULE_UPDATE_PII = 'SCHEDULE_UPDATE_PII',
  SCHEDULE_DELETE_PII = 'SCHEDULE_DELETE_PII',
  SCHEDULE_READ_LIVE = 'SCHEDULE_READ_LIVE',
  SCHEDULE_CREATE_LIVE = 'SCHEDULE_CREATE_LIVE',
  SCHEDULE_UPDATE_LIVE = 'SCHEDULE_UPDATE_LIVE',
  SCHEDULE_DELETE_LIVE = 'SCHEDULE_DELETE_LIVE',

  CUSTOMPACKAGE_READ = 'CUSTOMPACKAGE_READ',
  CUSTOMPACKAGE_CREATE = 'CUSTOMPACKAGE_CREATE',
  CUSTOMPACKAGE_DELETE = 'CUSTOMPACKAGE_DELETE',

  RUNBOOK_READ_NONPII = 'RUNBOOK_READ_NONPII',
  RUNBOOK_CREATE_NONPII = 'RUNBOOK_CREATE_NONPII',
  RUNBOOK_UPDATE_NONPII = 'RUNBOOK_UPDATE_NONPII',
  RUNBOOK_DELETE_NONPII = 'RUNBOOK_DELETE_NONPII',
  RUNBOOK_READ_PII = 'RUNBOOK_READ_PII',
  RUNBOOK_CREATE_PII = 'RUNBOOK_CREATE_PII',
  RUNBOOK_UPDATE_PII = 'RUNBOOK_UPDATE_PII',
  RUNBOOK_DELETE_PII = 'RUNBOOK_DELETE_PII',
  RUNBOOK_READ_LIVE = 'RUNBOOK_READ_LIVE',
  RUNBOOK_CREATE_LIVE = 'RUNBOOK_CREATE_LIVE',
  RUNBOOK_UPDATE_LIVE = 'RUNBOOK_UPDATE_LIVE',
  RUNBOOK_DELETE_LIVE = 'RUNBOOK_DELETE_LIVE',

  AUDIT_READ = "AUDIT_READ",
  GROUP_READ = "GROUP_READ",
  GROUP_CREATE = "GROUP_CREATE",
  GROUP_UPDATE = "GROUP_UPDATE",
  ROLE_READ = "ROLE_READ",
  ROLE_CREATE = "ROLE_CREATE",
  ROLE_UPDATE = "ROLE_UPDATE",
  ROLE_ASSIGN_READ = "ROLE_ASSIGN_READ",
  ROLE_ASSIGN_CREATE = "ROLE_ASSIGN_CREATE",
  ROLE_ASSIGN_UPDATE = "ROLE_ASSIGN_UPDATE",

  LOCAL_CONFIG_READ_NONPII = 'LOCAL_CONFIG_READ_NONPII',
  LOCAL_CONFIG_APPLY_NONPII = 'LOCAL_CONFIG_APPLY_NONPII',
  LOCAL_CONFIG_READ_PII = 'LOCAL_CONFIG_READ_PII',
  LOCAL_CONFIG_APPLY_PII = 'LOCAL_CONFIG_APPLY_PII',
  LOCAL_CONFIG_READ_LIVE = 'LOCAL_CONFIG_READ_LIVE',
  LOCAL_CONFIG_APPLY_LIVE = 'LOCAL_CONFIG_APPLY_LIVE',

  SIZING_CREATE_NONPII = 'SIZING_CREATE_NONPII',
  SIZING_CREATE_PII = 'SIZING_CREATE_PII',
  SIZING_CREATE_LIVE = 'SIZING_CREATE_LIVE',
  SIZING_READ_NONPII = 'SIZING_READ_NONPII',
  SIZING_READ_PII = 'SIZING_READ_PII',
  SIZING_READ_LIVE = 'SIZING_READ_LIVE',
  SIZING_UPDATE_NONPII = 'SIZING_UPDATE_NONPII',
  SIZING_UPDATE_PII = 'SIZING_UPDATE_PII',
  SIZING_UPDATE_LIVE = 'SIZING_UPDATE_LIVE',
  SIZING_DELETE_NONPII = 'SIZING_DELETE_NONPII',
  SIZING_DELETE_PII = 'SIZING_DELETE_PII',
  SIZING_DELETE_LIVE = 'SIZING_DELETE_LIVE'
  
}